// components/Phone.js
export const Phone = ({ type, rotation, translation, gradient }) => {
    const phoneContent = {
        artist: {
            name: '@artistname',
            role: 'Music Artist',
            initial: 'A',
            buttons: ['Latest Album', 'Tour Dates', 'Merch Store']
        },
        brand: {
            name: '@brandname',
            role: 'Fashion Brand',
            initial: 'B',
            buttons: ['Shop Now', 'Fall Collection', 'About Us']
        }
    }

    const content = phoneContent[type]

    return (
        <div className={`w-[280px] transform ${rotation} ${translation}`}>
            <div className="bg-black rounded-[3rem] p-4">
                <div className={`${type === 'brand' ? 'bg-gradient-to-br from-blue-50 to-purple-50' : 'bg-white'} rounded-[2.5rem] overflow-hidden aspect-[9/19.5]`}>
                    <div className="pt-12 px-6 text-center">
                        <div className={`w-20 h-20 bg-gradient-to-br ${gradient} rounded-full mx-auto mb-4 flex items-center justify-center text-white text-2xl`}>
                            {content.initial}
                        </div>
                        <h4 className="font-medium mb-2">{content.name}</h4>
                        <p className="text-sm text-gray-600 mb-6">{content.role}</p>
                        <div className="space-y-3">
                            {content.buttons.map((text, index) => (
                                <button
                                    key={index}
                                    className={`w-full ${index === 0
                                        ? type === 'artist'
                                            ? 'bg-black text-white'
                                            : `bg-gradient-to-r ${gradient} text-white`
                                        : 'bg-white/80 backdrop-blur border border-gray-200'
                                        } py-3 rounded-xl`}
                                >
                                    {text}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}